<div class="recherche-body">
    <frg-cards class="critere-list" title="Critères de recherche" [fullIcon]="fullIconAdd" (activatedFull)="loadSearch()">
        <table mat-table [dataSource]="listeCriteresRechercheDatasource">

            <!-- Position Column -->
            <ng-container matColumnDef="operator">
                <th mat-header-cell *matHeaderCellDef> Operateur </th>
                <td mat-cell *matCellDef="let element; let i = index;">
                    <select [(ngModel)]="element.operator" *ngIf="i > 0">
                        <option value="AND">
                            AND
                        </option>
                        <option value="OR">
                            OR
                        </option>
                    </select>
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="critereName">
                <th mat-header-cell *matHeaderCellDef> Nom </th>
                <td mat-cell *matCellDef="let element"> {{element.critereName}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="conditionName">
                <th mat-header-cell *matHeaderCellDef> Condition </th>
                <td mat-cell *matCellDef="let element"> {{element.conditionName}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef> Valeur </th>
                <td mat-cell *matCellDef="let element"> {{element.valueLabel}} <span *ngIf="element.subValue">({{element.subValue}})</span> </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button (click)="deleteCritere(element)">
                        <mat-icon class="mat-icon-rtl-mirror">
                            delete
                        </mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="button-container">
            <frg-button (click)="saveSearch()" class="full-size-button"
                [disabled]="!listeCriteresRecherche || listeCriteresRecherche.length === 0">
                <span>Enregistrer la recherche</span>
            </frg-button>
            <frg-button (click)="lancerRecherche()" class="full-size-button"
                [disabled]="!listeCriteresRecherche || listeCriteresRecherche.length === 0">
                <span>Lancer la recherche</span>
            </frg-button>
        </div>
    </frg-cards>
    <frg-cards class="critere-list" title="Ajouter un critère recherche">
        <div class="blocs-criteres">
            <div class="bloc-critere">
                <h2>Rechercher</h2>
                <div class="bloc-scrollable">
                    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="cursor: pointer;">
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding
                            (click)="selectNode(node)" [ngClass]="{ 'background-highlight': activeNode === node }">
                            <button mat-icon-button disabled></button>
                            {{node.name}}
                        </mat-tree-node>

                        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
                                <mat-icon class="mat-icon-rtl-mirror">
                                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                </mat-icon>
                            </button>
                            {{node.name}}
                        </mat-tree-node>
                    </mat-tree>
                </div>
            </div>
            <div class="bloc-critere">
                <h2>Conditions</h2>
                <div class="bloc-scrollable">
                    <mat-selection-list #conditions [multiple]="false" (selectionChange)="onConditionChange()">
                        <mat-list-option *ngFor="let condition of typesOfConditions" [value]="condition">
                            {{condition.label}}
                        </mat-list-option>
                    </mat-selection-list>
                </div>
            </div>
            <div class="bloc-critere">
                <h2 *ngIf="isValueSubList">Valeur</h2>
                <mat-form-field class="example-full-width" *ngIf="isValueSubList && activeNode.type !== 'duree' && activeNode.type !== 'critere' && activeNode.type !== 'groupement-criteres'">
                    <input matInput placeholder="Valeur du critère" [(ngModel)]="subTypedValue" type="text">
                </mat-form-field>
                <h2 *ngIf="!isValueSubList && !isCim10Critere">Valeurs possibles</h2>
                
                <!-- Barre de recherche pour les listes de valeurs normales (pas critère ni groupement-criteres) -->
                <div class="search" *ngIf="!isValueSubList && isValueList && !isCim10Critere && (!activeNode || (activeNode.type !== 'duree' && activeNode.type !== 'critere' && activeNode.type !== 'groupement-criteres'))">
                    <frg-search-input (search)="searchCritere($event)"></frg-search-input>
                </div>
                
                <!-- Champ de recherche CIM-10 pour les antécédents -->
                <div *ngIf="isCim10Critere" style="padding: 10px;">
                    <mat-form-field class="example-full-width">
                        <input matInput
                            (click)="openCim10Search()" 
                            placeholder="Rechercher un code CIM-10"
                            [value]="cim10Result?.libelle || ''"
                            readonly
                            type="text">
                        <mat-icon matSuffix style="cursor: pointer;" (click)="openCim10Search()">search</mat-icon>
                    </mat-form-field>
                    <div *ngIf="cim10Result" style="margin-top: 10px; padding: 10px; background-color: #f5f5f5; border-radius: 4px;">
                        <strong>Sélectionné :</strong> {{ cim10Result.libelle }} ({{ cim10Result.id.split('++')[0] }})
                    </div>
                </div>
                
                <!-- Saisie pour la durée uniquement -->
                <div class="duree-saisie" *ngIf="activeNode && activeNode.type === 'duree'">
                    <mat-form-field class="duree-field">
                        <input matInput placeholder="Durée" [(ngModel)]="subTypedValue"
                            (ngModelChange)="onNumberValueChange($event, activeNode.type)" type="number">
                    </mat-form-field>
                    <mat-form-field class="unite-duree-list">
                      <mat-select placeholder="Semaine(s), mois, année(s)..." (selectionChange)="onUniteDureeValueChange($event.value)">
                        <mat-option *ngFor="let pair of valueListFiltered" [value]="pair">
                            {{pair.label}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
                
                <!-- Saisie pour critère et groupement-criteres : recherche + saisie valeur + sélection -->
                <div class="duree-saisie" *ngIf="activeNode && (activeNode.type === 'critere' || activeNode.type === 'groupement-criteres')">
                    <div class="search">
                        <frg-search-input (search)="searchCritere($event)"></frg-search-input>
                    </div>
                    <mat-form-field class="duree-field">
                        <input *ngIf="activeNode && activeNode.type === 'critere'" matInput placeholder="Valeur du critère" [(ngModel)]="subTypedValue"
                            (ngModelChange)="onNumberValueChange($event, activeNode.type)" type="number">
                        <input *ngIf="activeNode && activeNode.type === 'groupement-criteres'" matInput placeholder="Valeur du groupement de critères" [(ngModel)]="subTypedValue"
                            (ngModelChange)="onNumberValueChange($event, activeNode.type)" type="number">
                    </mat-form-field>
                </div>
                
                <div class="bloc-scrollable-medium" [ngClass]="{'bloc-scrollable-small': isValueSubList}">
                    <!-- Saisie libre pour les types non-liste -->
                    <mat-form-field class="example-full-width" *ngIf="!isValueList && !isCim10Critere && typesOfConditions.length > 0 && (!activeNode || activeNode.type !== 'duree')">
                        <input matInput placeholder="Valeur du critère" [(ngModel)]="typedValue"
                            (ngModelChange)="onSelectedValueChange()" type="text" *ngIf="activeNode.type === 'string'">
                        <input matInput placeholder="Valeur du critère" [(ngModel)]="typedValue"
                            (ngModelChange)="onSelectedValueChange()" type="number"
                            *ngIf="activeNode.type === 'number'">
                        <input matInput placeholder="Valeur du critère" [(ngModel)]="typedValue"
                            (ngModelChange)="onSelectedValueChange()" type="date" *ngIf="activeNode.type === 'date'">
                    </mat-form-field>
                    
                    <!-- Liste déroulante pour les types liste (sauf critère et groupement-criteres qui ont leur propre section) -->
                    <mat-selection-list #values [multiple]="false" *ngIf="isValueList && !isCim10Critere && typesOfConditions.length > 0 && (!activeNode || (activeNode.type !== 'duree' && activeNode.type !== 'critere' && activeNode.type !== 'groupement-criteres'))"
                        (selectionChange)="onSelectedValueChange()">
                        <mat-list-option *ngFor="let pair of valueListFiltered" [value]="pair" [ngClass]="{ 'background-highlight': selectedValue?.value === pair.value }">
                            {{pair.label}}
                        </mat-list-option>
                    </mat-selection-list>
                    
                    <!-- Liste déroulante pour critère et groupement-criteres -->
                    <mat-selection-list #values [multiple]="false" *ngIf="activeNode && (activeNode.type === 'critere' || activeNode.type === 'groupement-criteres')"
                        (selectionChange)="onSelectedValueChange()">
                        <mat-list-option *ngFor="let pair of valueListFiltered" [value]="pair" [ngClass]="{ 'background-highlight': selectedValue?.value === pair.value }">
                            {{pair.label}}
                        </mat-list-option>
                    </mat-selection-list>
                </div>
            </div>
        </div>
        <button mat-menu-item (click)="addCritere()" class="full-size-button"
            [disabled]="(!selectedValue && !typedValue && !cim10Result) || !selectedCondition || !activeNode">
            <span>Ajouter un critère de recherche</span>
        </button>
    </frg-cards>
    <!-- Affiché en temps normal -->
    <frg-cards id="liste-patients" class="patient-list" title="Liste des patients" *ngIf="isSearching" [emptyIcon]="emptyIconEdit"
    (activatedEmpty)="exportToCsv()">
        <div class="patient-list-container">
            <frg-table [loading]="isTableLoading" [keysBody]="patientList" [keysColumn]="patientColumnTable"
                (onChangePage)="onChangePage($event)" (onSort)="onSort($event)" class="patient-table"
                [isRowsClickable]="true" (onClickRow)="openPatient($event)">
            </frg-table>
            <div class="total-list" *ngIf="patientList">Nombre de patients: {{patientList.total}}
            </div>
        </div>
        <br>
    </frg-cards>
</div>